// extracted by mini-css-extract-plugin
export default {"container":"N2Pky6","ratioImage":"QnYI6u"};